<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="会员ID：" prop="member_id">
                <el-input v-model="model.member_id"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email">
                <el-input v-model="model.email"></el-input>
            </el-form-item>
            <el-form-item label="RN：" prop="rn">
                <el-input v-model="model.rn"></el-input>
            </el-form-item>
            <el-form-item label="显示RN：" prop="rn1">
                <el-input v-model="model.rn1"></el-input>
            </el-form-item>
            <el-form-item label="订单状态：" prop="order_status">
                <el-input v-model="model.order_status"></el-input>
            </el-form-item>
            <el-form-item label="交付省份：" prop="location_province">
                <el-input v-model="model.location_province"></el-input>
            </el-form-item>
            <el-form-item label="交付城市：" prop="location_city">
                <el-input v-model="model.location_city"></el-input>
            </el-form-item>
            <el-form-item label="交付中心名称：" prop="location_title">
                <el-input v-model="model.location_title"></el-input>
            </el-form-item>
            <el-form-item label="车型：" prop="car_type">
                <el-input v-model="model.car_type"></el-input>
            </el-form-item>
            <el-form-item label="版本：" prop="banben">
                <el-input v-model="model.banben"></el-input>
            </el-form-item>
            <el-form-item label="颜色：" prop="yanse">
                <el-input v-model="model.yanse"></el-input>
            </el-form-item>
            <el-form-item label="颜色编码：" prop="yanse_code">
                <el-input v-model="model.yanse_code"></el-input>
            </el-form-item>
            <el-form-item label="轮毂：" prop="lungu">
                <el-input v-model="model.lungu"></el-input>
            </el-form-item>
            <el-form-item label="轮毂编码：" prop="lungu_code">
                <el-input v-model="model.lungu_code"></el-input>
            </el-form-item>
            <el-form-item label="内饰：" prop="neishi">
                <el-input v-model="model.neishi"></el-input>
            </el-form-item>
            <el-form-item label="内饰编码：" prop="neishi_code">
                <el-input v-model="model.neishi_code"></el-input>
            </el-form-item>
            <el-form-item label="订车时间：" prop="order_time">
                <el-input v-model="model.order_time"></el-input>
            </el-form-item>
            <el-form-item label="更新时间：" prop="update_time">
                <el-input v-model="model.update_time"></el-input>
            </el-form-item>
            <el-form-item label="交付时间：" prop="deliver_time">
                <el-input v-model="model.deliver_time"></el-input>
            </el-form-item>
            <el-form-item label="添加时间：" prop="add_time">
                <el-input v-model="model.add_time"></el-input>
            </el-form-item>
            <el-form-item label="是否轮循：" prop="is_loop">
                <el-input v-model="model.is_loop"></el-input>
            </el-form-item>
            <el-form-item label="是否入库：" prop="is_in_lib">
                <el-input v-model="model.is_in_lib"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'deliveryOrderEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                rn: '',
                rn1: '',
                order_status: '',
                location_province: '',
                location_city: '',
                location_title: '',
                car_type: '',
                banben: '',
                yanse: '',
                yanse_code: '',
                lungu: '',
                lungu_code: '',
                neishi: '',
                neishi_code: '',
                order_time: '',
                update_time: '',
                deliver_time: '',
                add_time: '',
                is_loop: '',
                is_in_lib: '',
            },
            getObj:{
                url:'/api/admin/deliveryorder/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                xxxname: [
                    {required: true, message: 'xxx名称不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/deliveryorder/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>